/*
 * Imports the custom elements scope suffix to avoid conflicts with other UI5 Web Components applications.
 */
import { setCustomElementsScopingSuffix } from '@ui5/webcomponents-base/dist/CustomElementsScope.js';
// we want to allow all existent tests to rely on generic UI5 web components names
const isTestEnvironment = typeof jest !== 'undefined' || typeof window?.Cypress !== 'undefined';
if (!isTestEnvironment) {
  setCustomElementsScopingSuffix('spg');
}
import { setTheme } from '@ui5/webcomponents-base/dist/config/Theme';
import { ThemeProvider } from '@ui5/webcomponents-react';

/**
 * Imports static assets that are required for
 * UI5 to work properly
 */
import '@ui5/webcomponents-react/dist/Assets';
import { jsx as _jsx } from "react/jsx-runtime";
void setTheme('sap_horizon');
export const UI5Theme = ({
  children
}) => /*#__PURE__*/_jsx(ThemeProvider, {
  children: children
});